import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CourseState } from './course.state';

export const featureKey = 'course';

export const courseFeature = createFeatureSelector<CourseState>(featureKey);

export const state = createSelector(courseFeature, (state: CourseState) => state);
export const courseActive = createSelector(courseFeature, ({ course_active }: CourseState) => course_active);
export const elementActive = createSelector(courseFeature, ({ element_active }: CourseState) => element_active);
